import { useQuery } from '@apollo/react-hooks';
import { AllMessageUnseen } from '../../graphql/discussion/types/AllMessageUnseen';
import { GET_ALL_MESSAGE_UNSEEN } from '../../graphql/discussion/query';

export const useGetAllMessageUnseen = () => {
  return useQuery<AllMessageUnseen>(GET_ALL_MESSAGE_UNSEEN, {
    fetchPolicy: 'cache-and-network',
    variables: { input: { isBackoffice: true } },
  });
};

export const useGetAllMessageUnseenDiscussion = () => {
  return useQuery<AllMessageUnseen>(GET_ALL_MESSAGE_UNSEEN, {
    fetchPolicy: 'cache-and-network',
    variables: { input: { isBackoffice: false } },
  });
};
